import apiClient from './client';
import type {AuthResponse, ChangePasswordInput, LoginCredentials, User} from '@/types/auth.ts';

// ========== AUTH API ==========

// Função de login
export const login = async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return response.data;
};

// Alterar senha
export const changePassword = async (data: ChangePasswordInput): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/auth/alter-password', data);
    return response.data;
};

// Salvar dados do usuário no localStorage
export const saveAuthData = (data: AuthResponse): void => {
    localStorage.setItem('access_token', data.token.access_token);
    localStorage.setItem('refresh_token', data.token.refresh_token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('token_expires_at', data.token.expires_at);
};

// Limpar dados do localStorage (logout)
export const clearAuthData = (): void => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('token_expires_at');
};

// Pegar usuário atual
export const getCurrentUser = (): User | null => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
};